import { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import ConcursoTrasladoNoResumen from "../cardsNoResumen/ConcursoTrasladoNoResumen";
// import { visualizarSeccionConcursos } from "../../services/ConcursosService";
// import { getDataAdqusicion } from "../../services/AdquisicionService";

// import ErrorConexion from "../cards/ErrorConexion";

const TramSelPro = () => {
  const [isVisible, initHs] = useState(true);
  // const [concursosVisible, setConcursosVisible] = useState(false);
  // const [adquisicion_habilitado, setAdquisicion_Habilitado] = useState({
  //   mostrarSeccion: null,
  // });
  // const [error_adqusicion, setError_adqusicion] = useState(false);
  const invokeCollapse = () => {
    return initHs(!isVisible);
  };

  // useEffect(() => {

  //   visualizarSeccionConcursos().then((data) => {
  //     setConcursosVisible(data);
  //   })
  // }, []);

  // useEffect(() => {
  //   if (localStorage.getItem("dataAdquisicion") === null) {
  //     getDataAdqusicion().then((data) => {
  //       if (!data.toString().startsWith("Error:")) {
  //         setAdquisicion_Habilitado(data);
  //         localStorage.setItem("dataAdquisicion", JSON.stringify(data));
  //       } else {
  //         setError_adqusicion(true);
  //       }
  //     });
  //   } else {
  //     setAdquisicion_Habilitado({
  //       mostrarSeccion: JSON.parse(localStorage.getItem("dataAdquisicion")).mostrarSeccion,
  //     });
  //   }
  // }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="" 
        onClick={invokeCollapse}
        role="button" 
        tabIndex={0} 
        title="Desplegar mis convocatorias"
        aria-label="Desplegar mis convocatorias"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            invokeCollapse()
          }
        }}>
          {/* <TituloCaja
            tipo={"tituloModal dropdown-toggle link"}
            titulo={"Mis convocatorias"}
          ></TituloCaja> */}
          <h2 className="tituloModal dropdown-toggle link">Mis convocatorias</h2>
        </div>
        <Collapse in={isVisible}>
          <div id="collapsePanel">
            <div className="card-group d-flex flex-column flex-md-row row">
              {/* {concursosVisible ? (  */}
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <ConcursoTrasladoNoResumen></ConcursoTrasladoNoResumen>
              </div>
              {/* ) : null} */}
              {/* {error_adqusicion ? (
                <div className=" col-3 col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <ErrorConexion titulo="Adquisición Especialidad Empleo (A1-A2)"></ErrorConexion>
                </div>
              ) : adquisicion_habilitado?.mostrarSeccion ? (<></>
                // <div className=" col-3 col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                //   <Adquisicion></Adquisicion>
                // </div>
              ) : adquisicion_habilitado?.mostrarSeccion === null ? (
                <div className=" col-3 col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <Placeholder></Placeholder>
                </div>
              ) : null} */}
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
export default TramSelPro;
